<div class="campaign-details" *ngIf="campaign">
  <div class="group group-brief">
    <div class="brief-title">
      <span class="title">{{"campaigns.new_campaign.brief" | translate}}</span>
    </div>
    <div class="group-content">
      <div class="group-text">{{campaign.campaign.brief}}</div>
    </div>
    <div class="included-mentions">
      <div class="title">{{"campaigns.new_campaign.included_mentions" | translate}}</div>
      <div class="mentions">
        <div class="tags" *ngIf="campaign.campaign.projectKeywords">
          <span class="tag" *ngFor="let kw of campaign.campaign.projectKeywords" >{{ kw.keyword.keyword }}</span>
        </div>
      </div>
    </div>
  </div>
  <info-group *ngIf="campaign.selectedTerms" class="group-business-terms" [title]="'campaigns.new_campaign.business_terms' | translate">
      <div class="business-terms">
        <div class="term" *ngFor="let term of campaign.selectedTerms">
          <span class="icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="10"
              height="12"
              viewBox="0 0 21.161 21.192"
            >
              <path
                fill="#95A0B1"
                d="M0 12.533l3.055-3.295 4.747 4.654c3.4-4.858 5.911-8.648 9.504-13.892 3.584 2.53.764.567 3.855 2.766-3.025 4.578-3.02 4.552-4.681 7.008-7.848 11.709-5.866 8.707-7.646 11.418-8.211-8.037-.399-.39-8.834-8.66z"
              />
            </svg> </span
          >{{ term.summary }}
        </div>
      </div>
  </info-group>
  <info-group *ngIf="campaign.compensation" class="group-compensation" [title]="'campaigns.new_campaign.compensation' | translate">
    <div class="compensation">
      <div class="summary">
        <table class="tbl-items">
          <tbody>
            <tr>
              <td>{{'campaigns.new_campaign.fixed_payment' | translate}}</td>
              <td>{{campaign.compensation.fixedPayment.unit}}{{campaign.compensation.fixedPayment.value}}</td>
            </tr>
            <tr>
              <td>{{'campaigns.new_campaign.performance_budget' | translate}}</td>
              <td>{{campaign.compensation.performanceBudget.unit}}{{campaign.compensation.performanceBudget.value}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="details">
        <table>
          <tbody>
            <tr *ngFor="let item of campaign.compensation.details">
              <td><img class="platform" alt="{{item.platform}}" src="{{item.icon}}" /></td>
              <td>{{'campaigns.new_campaign.cpm' | translate}}</td>
              <td>{{item.payment.unit}}{{item.payment.value}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </info-group>
  <info-group *ngIf="campaign.additionalInformation && campaign.additionalInformation.content" class="group-aditional-information" [title]="'campaigns.new_campaign.additional_information' | translate">
    <div class="group-text">{{ campaign.additionalInformation.content }}</div>
  </info-group>
  <info-group *ngIf="campaign.uploadMaterials && campaign.uploadMaterials.length" class="group-upload-materials" [title]="'campaigns.new_campaign.upload_materials' | translate">
    <div class="materials">
      <div class="material" *ngFor="let mat of campaign.uploadMaterials">
        <img *ngIf="isPdfFile(mat.contentType)" [alt]="mat.name" [src]="mat.image" onerror="this.src='assets/images/achoo-pdf.png'" />
        <img *ngIf="!isPdfFile(mat.contentType)" [alt]="mat.name" [src]="mat.image" onerror="this.src='assets/images/No_Image.png'" />
        <span class="name">{{ mat.name }}</span>
        <a class="icon download" (click)="downloadFile(mat)"></a>
      </div>
    </div>
  </info-group>
</div>
<div class="action-container" *ngIf="isShowButton()">
  <div class="campaign-details-loader" *ngIf="isConfirmingInfluencerNameAndEmail">
    <achoo-loader [normalPlaceholder]="true"></achoo-loader>
  </div>
  <div class="button-group">
    <button class="button decline-btn red" [disabled]="isConfirmingInfluencerNameAndEmail" (click)="onDecline()">{{'common.btn.decline' | translate}}</button>
    <button class="button blue" [disabled]="isConfirmingInfluencerNameAndEmail" (click)="onAcceptCampaign()">{{acceptButtonLabel}}</button>
  </div>
  <span [innerHTML]="'campaigns.achoo_footer_msg' | translate"></span>
</div>
<div class="decline-warning" *ngIf="showDeclineModal">
  <div class="modal-backdrop show"></div>
  <div class="modal-content" (clickOutside)="clickOutsideDeclineModal($event)">
    <a class="close" data-dismiss="modal" (click)="clickOutsideDeclineModal($event)" aria-label="Close">
      <img src="/assets/images/Add_Icon.svg" class="icon-close-popup">
    </a>
    <influencer-decline-modal (declineEvent)="acceptToDecline($event)"
                              (openContactEvent)="openContact()"
                              (closeModalEvent)="closeDeclineModal()">
    </influencer-decline-modal>
  </div>
</div>
<achoo-popup #AcceptCampaignPopup [isSpecialPopup]="true"
             (cancelCallback)="closeNotification()">
  <campaign-acception-popup [channelList]="listExistingChannel"
                            [activePage]="activePageBeforeAuthorizingFb"
                            (confirmChannel)="onConfirmChannel()">
  </campaign-acception-popup>
</achoo-popup>



// WEBPACK FOOTER //
// ./src/app/main/campaign-new/campaign-details/campaign-details.component.html